import classNames from 'classnames';
import type { FCC } from 'common/typeUtils';

import type { ComponentPropsWithoutRef, CSSProperties, ElementType } from 'react';
import styles from './RoundedPanel.module.css';

/**
 * Props not listed here are spread onto the rendered element. They are typed against `details`,
 * a superset of the plain element attributes, so `as="details"` can pass `open` and `onToggle`.
 */
type Props = {
  className?: string;
  as?: ElementType;
  color?: CSSProperties['background'];
  boxShadow?: boolean;
  style?: CSSProperties;
} & Omit<ComponentPropsWithoutRef<'details'>, 'color' | 'style' | 'className'>;

/**
 * Panel with rounded corners.
 * Default element is a section, defaut background is gray.
 */
export const RoundedPanel: FCC<Props> = ({
  children,
  className,
  as = 'section',
  color,
  boxShadow = false,
  style = {},
  ...rest
}) => {
  const Element = as;
  const mergedStyle = { '--rounded-panel-bg': color, ...style };
  return (
    <Element
      className={classNames(styles.roundedPanel, { [styles.boxShadow]: boxShadow }, className)}
      style={mergedStyle}
      {...rest}
    >
      {children}
    </Element>
  );
};
